export default "__VITE_ASSET__DBQrZBU$xvk9KsOre6JCwA__"